export default __webpack_public_path__ + "15ca31c0a2a68f76d2d12055bdf97bd0.woff2";